import React, { useState } from 'react'

import { connect } from 'react-redux'

import { loadVideolistsAllById, sortAllVideos, toggleSelectedVideoAll } from '../../../../../store/ContentAllVideolists/actions'
import { deleteVideosFromVideoList, loadAllPublicVideo, selectAllPlaylistClipsId } from '../../../../../store/ContentVideolists/actions'
import { sortVideos } from '../../../../../store/ContentVideolists/actions'
import TableHeader_Sort from './TableHeader/Sort'
import TableHeader_Buttons from './TableHeader/Buttons'
import TableHeader_Name from './TableHeader/Name'



const AllVideos = ({    
    songs = [],    
    selected,    
    all_public_content,
    videolist_content_all,
    addVideos,
    selectAllPlaylistClipsId,
    loadAllPublicVideo,
    toggleSelectedVideoAll,
    loadVideolistsAllById,
    deleteVideosFromVideoList
}) => {
    // if (searchActive) allSongs = searchFounded
    songs = [1, 2]
    const [sort_direction, setSortDirection] = useState("")


    const sort = (type) => {

        const direction = sort_direction === "up" ? "down" : "up"
        setSortDirection(direction)
        loadAllPublicVideo({
            offset: 0, sort_params: {
                sort_field: type,
                sort_dir: direction === 'up'
                    ? "ASC"
                    : "DESC"
            }
        })
        loadVideolistsAllById()
        // sortAllVideos({ direction, sort_type: type, id: selected[0] })
        // sortVideos({ direction, sort_type: type, id: selected[0] })

        return

    }




    return (
        <section className="" style={{ width: "61%", marginLeft: "2%" }}>
            <TableHeader_Name />
            <div style={{ marginTop: -36, marginBottom: 18 }}>
                <TableHeader_Buttons
                    addVideos={addVideos}
                    deleteVideosFromVideoList={deleteVideosFromVideoList}
                    selectAll={selectAllPlaylistClipsId}
                    toggleSelectedVideoAll={toggleSelectedVideoAll}

                />
            </div>
            <div>
                <TableHeader_Sort sort={sort} />
                {selected ? videolist_content_all : all_public_content}
            </div>

        </section>
    )
}

const stateToProps = state => ({
    selected: Boolean(state.videolists_all.selected.length),

})
const actionsToProps = {
    sortAllVideos,
    sortVideos,
    loadAllPublicVideo,
    toggleSelectedVideoAll,
    loadVideolistsAllById,
    selectAllPlaylistClipsId,
    deleteVideosFromVideoList
}

export default connect(stateToProps, actionsToProps)(AllVideos)